import type { Group } from "../../../interfaces/Session";

const queryKeys = {
  getDashboardClassroom: (teacherId: string, classroomId: string) =>
    ["dashboardClassroom", { teacherId, classroomId }] as const,
  getDashboardClassrooms: (teacherId: string, classroomsList: string[]) =>
    ["dashboardClassroom", { teacherId, classroomsList }] as const,
  getDashboard: (teacherId: string, classroomsList: Group[]) =>
    ["dashboard", { teacherId, classroomsList }] as const,
  getLearningSet: (learningSetId: string, queryParams: { depth?: number }) =>
    ["mapping", learningSetId, queryParams] as const,
  getExternalRedirection: (url: string) =>
    ["externalRedirection", url] as const,
  getClassroomsStudentsAlerts: (classroomIds: string[], moduleIds: string[]) =>
    ["classroomsStudentsAlerts", classroomIds, moduleIds] as const,
};
export default queryKeys;
